import React, { FC, useState, useEffect } from "react";
import * as M from "moment";
import styles from "../styles.module.scss";
import Constants from "../../../constants/Common";
import { Row, Col } from "antd";
import { IButton, IDatePicker } from "../../../ui-kit";
import { useHandleForm } from "../../../hooks/useHandleForm";
import { Controller } from "react-hook-form";
import dictionaryStore from "../../../store/dictionary";
import { observer } from "mobx-react-lite";

interface IDictionaryVersionProps {
  dictionaryId: number,
  dictionaryName: string
}

const DictionaryVersion: FC<IDictionaryVersionProps> = observer(({dictionaryId, dictionaryName}) => {
  const DEFAULT_VALUES = {versionDate: "",dictionaryId,dictionaryName};
  const DEFAULT_FOCUS = {date: false};
  
  const {
    errors,
    control,
    getValues,
    formState: {isDirty}
  } = useHandleForm(null,DEFAULT_VALUES,DEFAULT_FOCUS);

  const downloadDictionaryVersion = () => {
    const values = getValues();
    values.versionDate = values.versionDate.format("YYYY-MM-DD");
    values.dictName = dictionaryName;
    dictionaryStore.downloadDictionaryVersion(values);
  }


  return (
    <div
      className={styles.dictionaryVersion}
    >
      <div className={styles.dictionaryVersion__title}>
        <p>
          Предыдущие версии справочника
        </p>
      </div>
      <div className={styles.dictionaryVersion__form}>
        <Row gutter={[10,10]}>
          <Col span={18}>
            <Controller
              control={control}
              name="versionDate"
              render={({ field }) => (
                <IDatePicker
                  field={field}
                  placeholder={"Дата"}
                />
              )}
            />
          </Col>
          <Col span={4}>
            <IButton
              type="submit"
              disabled={dictionaryStore.isLoadingVersion.value || !isDirty}
              onClick={downloadDictionaryVersion}
            >
              Скачать
            </IButton>
          </Col>
        </Row>
      </div>
    </div>
  );
});

export default DictionaryVersion;